"use strict";
"use client";

var _excluded = ["__scopePopper", "virtualRef"],
  _excluded2 = ["__scopePopper", "side", "sideOffset", "align", "alignOffset", "arrowPadding", "avoidCollisions", "collisionBoundary", "collisionPadding", "sticky", "hideWhenDetached", "updatePositionStrategy", "onPlaced"],
  _excluded3 = ["__scopePopper"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function __export(target, all) {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};
var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && _typeof(from) === "object" || typeof from === "function") {
    var _iterator = _createForOfIteratorHelper(__getOwnPropNames(from)),
      _step;
    try {
      var _loop = function _loop() {
        var key = _step.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return to;
};
var __toESM = function __toESM(mod, isNodeMode, target) {
  return target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
    value: mod,
    enumerable: true
  }) : target, mod);
};
var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
};

// packages/react/popper/src/index.ts
var src_exports = {};
__export(src_exports, {
  ALIGN_OPTIONS: function ALIGN_OPTIONS() {
    return _ALIGN_OPTIONS;
  },
  Anchor: function Anchor() {
    return _Anchor;
  },
  Arrow: function Arrow() {
    return _Arrow;
  },
  Content: function Content() {
    return _Content;
  },
  Popper: function Popper() {
    return _Popper;
  },
  PopperAnchor: function PopperAnchor() {
    return _PopperAnchor;
  },
  PopperArrow: function PopperArrow() {
    return _PopperArrow;
  },
  PopperContent: function PopperContent() {
    return _PopperContent;
  },
  Root: function Root() {
    return Root2;
  },
  SIDE_OPTIONS: function SIDE_OPTIONS() {
    return _SIDE_OPTIONS;
  },
  createPopperScope: function createPopperScope() {
    return _createPopperScope;
  }
});
module.exports = __toCommonJS(src_exports);

// packages/react/popper/src/Popper.tsx
var React = __toESM(require("react"));
var import_react_dom = require("@floating-ui/react-dom");
var ArrowPrimitive = __toESM(require("@radix-ui/react-arrow"));
var import_react_compose_refs = require("@radix-ui/react-compose-refs");
var import_react_context = require("@radix-ui/react-context");
var import_react_primitive = require("@radix-ui/react-primitive");
var import_react_use_callback_ref = require("@radix-ui/react-use-callback-ref");
var import_react_use_layout_effect = require("@radix-ui/react-use-layout-effect");
var import_react_use_size = require("@radix-ui/react-use-size");
var import_jsx_runtime = require("react/jsx-runtime");
var _SIDE_OPTIONS = ["top", "right", "bottom", "left"];
var _ALIGN_OPTIONS = ["start", "center", "end"];
var POPPER_NAME = "Popper";
var _ref = (0, import_react_context.createContextScope)(POPPER_NAME),
  _ref2 = _slicedToArray(_ref, 2),
  createPopperContext = _ref2[0],
  _createPopperScope = _ref2[1];
var _createPopperContext = createPopperContext(POPPER_NAME),
  _createPopperContext2 = _slicedToArray(_createPopperContext, 2),
  PopperProvider = _createPopperContext2[0],
  usePopperContext = _createPopperContext2[1];
var _Popper = function _Popper(props) {
  var __scopePopper = props.__scopePopper,
    children = props.children;
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    anchor = _React$useState2[0],
    setAnchor = _React$useState2[1];
  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(PopperProvider, {
    scope: __scopePopper,
    anchor: anchor,
    onAnchorChange: setAnchor,
    children: children
  });
};
_Popper.displayName = POPPER_NAME;
var ANCHOR_NAME = "PopperAnchor";
var _PopperAnchor = React.forwardRef(function (props, forwardedRef) {
  var __scopePopper = props.__scopePopper,
    virtualRef = props.virtualRef,
    anchorProps = _objectWithoutProperties(props, _excluded);
  var context = usePopperContext(ANCHOR_NAME, __scopePopper);
  var ref = React.useRef(null);
  var composedRefs = (0, import_react_compose_refs.useComposedRefs)(forwardedRef, ref);
  React.useEffect(function () {
    context.onAnchorChange((virtualRef === null || virtualRef === void 0 ? void 0 : virtualRef.current) || ref.current);
  });
  return virtualRef ? null : /* @__PURE__ */(0, import_jsx_runtime.jsx)(import_react_primitive.Primitive.div, _objectSpread(_objectSpread({}, anchorProps), {}, {
    ref: composedRefs
  }));
});
_PopperAnchor.displayName = ANCHOR_NAME;
var CONTENT_NAME = "PopperContent";
var _createPopperContext3 = createPopperContext(CONTENT_NAME),
  _createPopperContext4 = _slicedToArray(_createPopperContext3, 2),
  PopperContentProvider = _createPopperContext4[0],
  useContentContext = _createPopperContext4[1];
var _PopperContent = React.forwardRef(function (props, forwardedRef) {
  var _arrowSize$width, _arrowSize$height, _middlewareData$arrow, _middlewareData$arrow2, _middlewareData$arrow3, _middlewareData$trans, _middlewareData$trans2, _middlewareData$hide;
  var __scopePopper = props.__scopePopper,
    _props$side = props.side,
    side = _props$side === void 0 ? "bottom" : _props$side,
    _props$sideOffset = props.sideOffset,
    sideOffset = _props$sideOffset === void 0 ? 0 : _props$sideOffset,
    _props$align = props.align,
    align = _props$align === void 0 ? "center" : _props$align,
    _props$alignOffset = props.alignOffset,
    alignOffset = _props$alignOffset === void 0 ? 0 : _props$alignOffset,
    _props$arrowPadding = props.arrowPadding,
    arrowPadding = _props$arrowPadding === void 0 ? 0 : _props$arrowPadding,
    _props$avoidCollision = props.avoidCollisions,
    avoidCollisions = _props$avoidCollision === void 0 ? true : _props$avoidCollision,
    _props$collisionBound = props.collisionBoundary,
    collisionBoundary = _props$collisionBound === void 0 ? [] : _props$collisionBound,
    _props$collisionPaddi = props.collisionPadding,
    collisionPaddingProp = _props$collisionPaddi === void 0 ? 0 : _props$collisionPaddi,
    _props$sticky = props.sticky,
    sticky = _props$sticky === void 0 ? "partial" : _props$sticky,
    _props$hideWhenDetach = props.hideWhenDetached,
    hideWhenDetached = _props$hideWhenDetach === void 0 ? false : _props$hideWhenDetach,
    _props$updatePosition = props.updatePositionStrategy,
    updatePositionStrategy = _props$updatePosition === void 0 ? "optimized" : _props$updatePosition,
    onPlaced = props.onPlaced,
    contentProps = _objectWithoutProperties(props, _excluded2);
  var context = usePopperContext(CONTENT_NAME, __scopePopper);
  var _React$useState3 = React.useState(null),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    content = _React$useState4[0],
    setContent = _React$useState4[1];
  var composedRefs = (0, import_react_compose_refs.useComposedRefs)(forwardedRef, function (node) {
    return setContent(node);
  });
  var _React$useState5 = React.useState(null),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    arrow = _React$useState6[0],
    setArrow = _React$useState6[1];
  var arrowSize = (0, import_react_use_size.useSize)(arrow);
  var arrowWidth = (_arrowSize$width = arrowSize === null || arrowSize === void 0 ? void 0 : arrowSize.width) !== null && _arrowSize$width !== void 0 ? _arrowSize$width : 0;
  var arrowHeight = (_arrowSize$height = arrowSize === null || arrowSize === void 0 ? void 0 : arrowSize.height) !== null && _arrowSize$height !== void 0 ? _arrowSize$height : 0;
  var desiredPlacement = side + (align !== "center" ? "-" + align : "");
  var collisionPadding = typeof collisionPaddingProp === "number" ? collisionPaddingProp : _objectSpread({
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  }, collisionPaddingProp);
  var boundary = Array.isArray(collisionBoundary) ? collisionBoundary : [collisionBoundary];
  var hasExplicitBoundaries = boundary.length > 0;
  var detectOverflowOptions = {
    padding: collisionPadding,
    boundary: boundary.filter(isNotNull),
    // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
    altBoundary: hasExplicitBoundaries
  };
  var _ref3 = (0, import_react_dom.useFloating)({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: desiredPlacement,
      whileElementsMounted: function whileElementsMounted() {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        var cleanup = (0, import_react_dom.autoUpdate).apply(void 0, args.concat([{
          animationFrame: updatePositionStrategy === "always"
        }]));
        return cleanup;
      },
      elements: {
        reference: context.anchor
      },
      middleware: [(0, import_react_dom.offset)({
        mainAxis: sideOffset + arrowHeight,
        alignmentAxis: alignOffset
      }), avoidCollisions && (0, import_react_dom.shift)(_objectSpread({
        mainAxis: true,
        crossAxis: false,
        limiter: sticky === "partial" ? (0, import_react_dom.limitShift)() : void 0
      }, detectOverflowOptions)), avoidCollisions && (0, import_react_dom.flip)(_objectSpread({}, detectOverflowOptions)), (0, import_react_dom.size)(_objectSpread(_objectSpread({}, detectOverflowOptions), {}, {
        apply: function apply(_ref4) {
          var elements = _ref4.elements,
            rects = _ref4.rects,
            availableWidth = _ref4.availableWidth,
            availableHeight = _ref4.availableHeight;
          var _rects$reference = rects.reference,
            anchorWidth = _rects$reference.width,
            anchorHeight = _rects$reference.height;
          var contentStyle = elements.floating.style;
          contentStyle.setProperty("--radix-popper-available-width", "".concat(availableWidth, "px"));
          contentStyle.setProperty("--radix-popper-available-height", "".concat(availableHeight, "px"));
          contentStyle.setProperty("--radix-popper-anchor-width", "".concat(anchorWidth, "px"));
          contentStyle.setProperty("--radix-popper-anchor-height", "".concat(anchorHeight, "px"));
        }
      })), arrow && (0, import_react_dom.arrow)({
        element: arrow,
        padding: arrowPadding
      }), transformOrigin({
        arrowWidth: arrowWidth,
        arrowHeight: arrowHeight
      }), hideWhenDetached && (0, import_react_dom.hide)(_objectSpread({
        strategy: "referenceHidden"
      }, detectOverflowOptions))]
    }),
    refs = _ref3.refs,
    floatingStyles = _ref3.floatingStyles,
    placement = _ref3.placement,
    isPositioned = _ref3.isPositioned,
    middlewareData = _ref3.middlewareData;
  var _getSideAndAlignFromP = getSideAndAlignFromPlacement(placement),
    _getSideAndAlignFromP2 = _slicedToArray(_getSideAndAlignFromP, 2),
    placedSide = _getSideAndAlignFromP2[0],
    placedAlign = _getSideAndAlignFromP2[1];
  var handlePlaced = (0, import_react_use_callback_ref.useCallbackRef)(onPlaced);
  (0, import_react_use_layout_effect.useLayoutEffect)(function () {
    if (isPositioned) {
      handlePlaced === null || handlePlaced === void 0 || handlePlaced();
    }
  }, [isPositioned, handlePlaced]);
  var arrowX = (_middlewareData$arrow = middlewareData.arrow) === null || _middlewareData$arrow === void 0 ? void 0 : _middlewareData$arrow.x;
  var arrowY = (_middlewareData$arrow2 = middlewareData.arrow) === null || _middlewareData$arrow2 === void 0 ? void 0 : _middlewareData$arrow2.y;
  var cannotCenterArrow = ((_middlewareData$arrow3 = middlewareData.arrow) === null || _middlewareData$arrow3 === void 0 ? void 0 : _middlewareData$arrow3.centerOffset) !== 0;
  var _React$useState7 = React.useState(),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    contentZIndex = _React$useState8[0],
    setContentZIndex = _React$useState8[1];
  (0, import_react_use_layout_effect.useLayoutEffect)(function () {
    if (content) setContentZIndex(window.getComputedStyle(content).zIndex);
  }, [content]);
  return /* @__PURE__ */(0, import_jsx_runtime.jsx)("div", {
    ref: refs.setFloating,
    "data-radix-popper-content-wrapper": "",
    style: _objectSpread(_objectSpread({}, floatingStyles), {}, _defineProperty({
      transform: isPositioned ? floatingStyles.transform : "translate(0, -200%)",
      // keep off the page when measuring
      minWidth: "max-content",
      zIndex: contentZIndex
    }, "--radix-popper-transform-origin", [(_middlewareData$trans = middlewareData.transformOrigin) === null || _middlewareData$trans === void 0 ? void 0 : _middlewareData$trans.x, (_middlewareData$trans2 = middlewareData.transformOrigin) === null || _middlewareData$trans2 === void 0 ? void 0 : _middlewareData$trans2.y].join(" ")), ((_middlewareData$hide = middlewareData.hide) === null || _middlewareData$hide === void 0 ? void 0 : _middlewareData$hide.referenceHidden) && {
      visibility: "hidden",
      pointerEvents: "none"
    }),
    dir: props.dir,
    children: /* @__PURE__ */(0, import_jsx_runtime.jsx)(PopperContentProvider, {
      scope: __scopePopper,
      placedSide: placedSide,
      onArrowChange: setArrow,
      arrowX: arrowX,
      arrowY: arrowY,
      shouldHideArrow: cannotCenterArrow,
      children: /* @__PURE__ */(0, import_jsx_runtime.jsx)(import_react_primitive.Primitive.div, _objectSpread(_objectSpread({
        "data-side": placedSide,
        "data-align": placedAlign
      }, contentProps), {}, {
        ref: composedRefs,
        style: _objectSpread(_objectSpread({}, contentProps.style), {}, {
          // if the PopperContent hasn't been placed yet (not all measurements done)
          // we prevent animations so that users's animation don't kick in too early referring wrong sides
          animation: !isPositioned ? "none" : void 0
        })
      }))
    })
  });
});
_PopperContent.displayName = CONTENT_NAME;
var ARROW_NAME = "PopperArrow";
var OPPOSITE_SIDE = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
};
var _PopperArrow = React.forwardRef(function PopperArrow2(props, forwardedRef) {
  var __scopePopper = props.__scopePopper,
    arrowProps = _objectWithoutProperties(props, _excluded3);
  var contentContext = useContentContext(ARROW_NAME, __scopePopper);
  var baseSide = OPPOSITE_SIDE[contentContext.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */
    (0, import_jsx_runtime.jsx)("span", {
      ref: contentContext.onArrowChange,
      style: _defineProperty(_defineProperty(_defineProperty(_defineProperty({
        position: "absolute",
        left: contentContext.arrowX,
        top: contentContext.arrowY
      }, baseSide, 0), "transformOrigin", {
        top: "",
        right: "0 0",
        bottom: "center 0",
        left: "100% 0"
      }[contentContext.placedSide]), "transform", {
        top: "translateY(100%)",
        right: "translateY(50%) rotate(90deg) translateX(-50%)",
        bottom: "rotate(180deg)",
        left: "translateY(50%) rotate(-90deg) translateX(50%)"
      }[contentContext.placedSide]), "visibility", contentContext.shouldHideArrow ? "hidden" : void 0),
      children: /* @__PURE__ */(0, import_jsx_runtime.jsx)(ArrowPrimitive.Root, _objectSpread(_objectSpread({}, arrowProps), {}, {
        ref: forwardedRef,
        style: _objectSpread(_objectSpread({}, arrowProps.style), {}, {
          // ensures the element can be measured correctly (mostly for if SVG)
          display: "block"
        })
      }))
    })
  );
});
_PopperArrow.displayName = ARROW_NAME;
function isNotNull(value) {
  return value !== null;
}
var transformOrigin = function transformOrigin(options) {
  return {
    name: "transformOrigin",
    options: options,
    fn: function fn(data) {
      var _middlewareData$arrow4, _middlewareData$arrow5, _middlewareData$arrow6, _middlewareData$arrow7, _middlewareData$arrow8;
      var placement = data.placement,
        rects = data.rects,
        middlewareData = data.middlewareData;
      var cannotCenterArrow = ((_middlewareData$arrow4 = middlewareData.arrow) === null || _middlewareData$arrow4 === void 0 ? void 0 : _middlewareData$arrow4.centerOffset) !== 0;
      var isArrowHidden = cannotCenterArrow;
      var arrowWidth = isArrowHidden ? 0 : options.arrowWidth;
      var arrowHeight = isArrowHidden ? 0 : options.arrowHeight;
      var _getSideAndAlignFromP3 = getSideAndAlignFromPlacement(placement),
        _getSideAndAlignFromP4 = _slicedToArray(_getSideAndAlignFromP3, 2),
        placedSide = _getSideAndAlignFromP4[0],
        placedAlign = _getSideAndAlignFromP4[1];
      var noArrowAlign = {
        start: "0%",
        center: "50%",
        end: "100%"
      }[placedAlign];
      var arrowXCenter = ((_middlewareData$arrow5 = (_middlewareData$arrow6 = middlewareData.arrow) === null || _middlewareData$arrow6 === void 0 ? void 0 : _middlewareData$arrow6.x) !== null && _middlewareData$arrow5 !== void 0 ? _middlewareData$arrow5 : 0) + arrowWidth / 2;
      var arrowYCenter = ((_middlewareData$arrow7 = (_middlewareData$arrow8 = middlewareData.arrow) === null || _middlewareData$arrow8 === void 0 ? void 0 : _middlewareData$arrow8.y) !== null && _middlewareData$arrow7 !== void 0 ? _middlewareData$arrow7 : 0) + arrowHeight / 2;
      var x = "";
      var y = "";
      if (placedSide === "bottom") {
        x = isArrowHidden ? noArrowAlign : "".concat(arrowXCenter, "px");
        y = "".concat(-arrowHeight, "px");
      } else if (placedSide === "top") {
        x = isArrowHidden ? noArrowAlign : "".concat(arrowXCenter, "px");
        y = "".concat(rects.floating.height + arrowHeight, "px");
      } else if (placedSide === "right") {
        x = "".concat(-arrowHeight, "px");
        y = isArrowHidden ? noArrowAlign : "".concat(arrowYCenter, "px");
      } else if (placedSide === "left") {
        x = "".concat(rects.floating.width + arrowHeight, "px");
        y = isArrowHidden ? noArrowAlign : "".concat(arrowYCenter, "px");
      }
      return {
        data: {
          x: x,
          y: y
        }
      };
    }
  };
};
function getSideAndAlignFromPlacement(placement) {
  var _placement$split = placement.split("-"),
    _placement$split2 = _slicedToArray(_placement$split, 2),
    side = _placement$split2[0],
    _placement$split2$ = _placement$split2[1],
    align = _placement$split2$ === void 0 ? "center" : _placement$split2$;
  return [side, align];
}
var Root2 = _Popper;
var _Anchor = _PopperAnchor;
var _Content = _PopperContent;
var _Arrow = _PopperArrow;